import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { ErrorToaster, SuccessToaster } from "../../components/toaster/Toaster";
import CategoryServices from "../../../services/Category";
import CategoryForm from "./categoryForm";

const EditCategory = () => {

  const route = all_routes;
  const navigate = useNavigate();
  const { id } = useParams();

  const [loading, setLoading] = useState(false);

  // *For Update Category
  const updateCategory = async (formData) => {
    setLoading(true)
    try {
      await CategoryServices.updateCategory(id, formData)
      SuccessToaster('Update Successfully')
      navigate(route?.categories)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Update Category</h4>
            </div>
          </div>
        </div>
        <CategoryForm onSubmit={updateCategory} loading={loading} />
      </div >
    </div >
  );
};

export default EditCategory;
